import React, { useEffect, useState } from 'react';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { getUserPageAuth } from '../../../../utils/page-auth';
import Visible from '../../../../components/Custom/Visible';
import Notification from '../../../../components/Notification/Notification';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';
import useSchemaPartnerManage from '../../../../schema/table-schema/useSchemaPartnerManage';
import {
  eventPartnerCreateRequest,
  eventPartnerListRequest,
} from '../../../../redux/actions/event/eventPartnerActions';
import BOTable from '../../../../components/Tables/BOTable';
import { useHistory } from 'react-router';
import useTranslation from '../../../../hooks/useTranslation';
import {Box, Modal} from "@mui/material";
import {t} from "../../../../i18n";
import btnIcons from "../../../../api/images/btnIcons";

function PartnerManageMain() {
  // -- component const --//
  const title = 'admin.event.newUser.partner.manage.title'; // '파트너사 관리';
  const OPTION_KEY = Page.EVENT_INVITATION;

  const { t } = useTranslation();
  const { schema } = useSchemaPartnerManage();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);
  const history = useHistory();

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [partnerId, setPartnerId] = useState('');
  const [partnerCode, setPartnerCode] = useState('');

  const [tBody, setTbody] = useState();
  const [totalCount, setTotalCount] = useState(0);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(25);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      eventPartnerListRequest({
        page: page,
        pageLength: Number(pageLength),
        callback: (data) => {
          console.log('요청 결과: ', data);
          setTotalCount(data?.totalCount);
          // setTbody(data?.list);

          // 인덱스를 추가하여 새로운 배열을 생성(중복 키 방지)
          const listWithIndex = data?.list.map((item, index) => ({
            index: index + 1, // 인덱스는 1부터 시작(번호 표기시 편의를 위해)
            ...item,
          }));

          setTbody(listWithIndex);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      }),
    );
  };

  const handleSubmit = () => {
    dispatch(
      eventPartnerCreateRequest({
        partnerEmail: partnerId,
        invCode: partnerCode,
        callback: (data) => {
          console.log('요청 결과: ', data);

          fetchList();
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          fetchList();
        },
      }),
    );
  };

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(Number(value));
    setPage(1);
  };

  const handleClickRow = (row) => {
    if (row?.accountNo) {
      const accountNo = row.accountNo;
      history.push('/admin/event/newUser/partnerManage/Details', {
        accountNo,
      });
    }
  };

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <section className="topSection">
          <div className="leftSection">
              <p className="titleText">
                  {t(title)}
                  {readOnly ? '(읽기전용)' : ''}
              </p>
          </div>

          <div className="rightSection">
              <button
                  className={"outlineBtn"}
                  onClick={() => {
                      fetchList();
                  }}
              >
                  List 갱신
              </button>
              <button
                  className="defaultBtn"
                  onClick={() => {
                      setIsModalOpen(true);
                  }}
                  disabled={readOnly}
              >
                  새 파트너사 등록
              </button>
          </div>
      </section>

      {/*<div className="contentsArea paddingAll">*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="descDiv date">*/}
      {/*      <input*/}
      {/*        value={partnerId}*/}
      {/*        onChange={(e) => setPartnerId(e.target.value.trim())}*/}
      {/*        placeholder={'파트너사 계정 이메일'}*/}
      {/*        disabled={readOnly}*/}
      {/*      />*/}

      {/*      <input*/}
      {/*        value={partnerCode}*/}
      {/*        onChange={(e) => {*/}
      {/*          const inputValue = e.target.value;*/}
      {/*          const isKoreanInput = /[ㄱ-ㅎ|ㅏ-ㅣ가-힣]/.test(inputValue);*/}

      {/*          if (isKoreanInput) {*/}
      {/*            setShowNotification(true);*/}
      {/*            setNotificationMessage('코드에 한글 사용 불가.');*/}
      {/*            return false;*/}
      {/*          }*/}

      {/*          setPartnerCode(inputValue.toUpperCase()*/}
      {/*            .trim());*/}
      {/*        }}*/}
      {/*        placeholder={'20자 이하 영어 및 숫자'}*/}
      {/*        maxLength={20}*/}
      {/*        disabled={readOnly}*/}
      {/*      />*/}

      {/*      <button*/}
      {/*        className="defaultBtn error"*/}
      {/*        onClick={() => {*/}
      {/*          setPartnerId('');*/}
      {/*          setPartnerCode('');*/}
      {/*        }}*/}
      {/*        disabled={readOnly}*/}
      {/*      >*/}
      {/*        취소*/}
      {/*      </button>*/}


      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*<div className="spaceDiv10"/>*/}


      <div className="spaceDiv10"/>

      <Visible visible={pageOption?.top_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      <div className="spaceDiv10"/>

      <BOTable
        className={'partnerManageTable'}
        schema={schema}
        rows={tBody}
        loading={isLoading}
        onClick={handleClickRow}
      />

      <div className="spaceDiv10"/>

      <Visible visible={pageOption?.bottom_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

    <Modal
        open={isModalOpen}
        onClose={() => {setIsModalOpen(false)}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Box className="modalBox" style={{minWidth : 300}}>

            <div className="modalTitle" style={{display : "flex", alignItems : "center", justifyContent: "space-between"}}>
                새 파트너사 등록
                <img
                    src={btnIcons.closeIcon}
                    onClick={() => {setIsModalOpen(false)}}
                    style={{ cursor: 'pointer', float: 'right' }}
                />
            </div>

            <div className="sectionLine" />
            <div className="spaceDiv10"></div>

            <div className="rowDiv" style={{flexDirection: "column", alignItems: "flex-start"}}>
                <input
                    onChange={(e) => setPartnerId(e.target.value.trim())}
                    value={partnerId}
                    placeholder={"파트너사 이메일"}
                    type="text"
                    style={{width : "100%"}}
                />
                <input
                    onChange={(e) => setPartnerCode(e.target.value.trim())}
                    value={partnerCode}
                    placeholder={"추천 코드"}
                    type="text"
                    style={{width : "100%"}}
                    pattern={/^[A-Z0-9]{1,20}$/}
                />
            </div>

            <div className="spaceDiv10"></div>

            <div className="rightSection">
                <button
                    className="defaultBtn"
                    onClick={() => {handleSubmit(); setPartnerId(""); setPartnerCode(""); }}
                >
                    등록하기
                </button>
            </div>


        </Box>
    </Modal>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default PartnerManageMain;
